// Global time. One scalar, but it reaches every stage, which is why it is its
// own group rather than a field parameter.

export const clockParams = [
  { key: 'rate', label: 'rate', tier: 'continuous', min: 0, max: 3, step: 0.05, default: 1, format: 'x' },
  { key: 'phase', label: 'phase', tier: 'continuous', min: 0, max: 6.283, step: 0.01, default: 0 },
  { key: 'loop', label: 'loop length', tier: 'continuous', min: 0, max: 60, step: 0.5, default: 0, hint: '0 = free-running' },
]

export function createClock(cfg) {
  let t = 0
  return {
    advance(dtSeconds) {
      t += dtSeconds * cfg.rate
      if (cfg.loop > 0) t %= cfg.loop
      return t + cfg.phase
    },
    // Deterministic seek — what makes scrubbing and frame-exact export possible.
    at(time) {
      return (cfg.loop > 0 ? time % cfg.loop : time) * cfg.rate + cfg.phase
    },
    get time() { return t },
    set time(v) { t = v },
  }
}
